import { CircleInfoIcon, MinusIcon, PlusIcon } from '@persona-id/design-tokens/icons';
import { ReactElement } from 'react';
import styled from 'styled-components';

import { VersionDiffChangeType } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { FlowEditorHighlightColorVariant } from 'dashboard/components/FlowEditorNodeHighlighter';
import Tooltip from 'design-system/components/Tooltip';

const StyledDiv = styled.div`
  display: inline-flex;
  align-items: center;
`;

const TooltipWrapper = ({
  children,
  tooltipContent,
}: {
  children: ReactElement;
  tooltipContent: string;
}) => {
  return (
    <Tooltip interactive={false} side='top' trigger={children} delayDuration={300}>
      {tooltipContent}
    </Tooltip>
  );
};

const DiffIcon = ({ changeType }: { changeType: VersionDiffChangeType | null }) => {
  switch (changeType) {
    case VersionDiffChangeType.ADDED:
      return (
        <TooltipWrapper tooltipContent='Added'>
          <StyledDiv>
            <PlusIcon color={FlowEditorHighlightColorVariant[changeType]} />
          </StyledDiv>
        </TooltipWrapper>
      );
    case VersionDiffChangeType.REMOVED:
      return (
        <TooltipWrapper tooltipContent='Removed'>
          <StyledDiv>
            <MinusIcon color={FlowEditorHighlightColorVariant[changeType]} />
          </StyledDiv>
        </TooltipWrapper>
      );
    case VersionDiffChangeType.MODIFIED:
      return (
        <TooltipWrapper tooltipContent='Modified'>
          <StyledDiv>
            <CircleInfoIcon color={FlowEditorHighlightColorVariant[changeType]} />
          </StyledDiv>
        </TooltipWrapper>
      );
    default:
      return <></>;
  }
};

export default DiffIcon;
